import React from 'react';
import { func, bool } from 'prop-types';
import { Modal, notification } from 'antd';
import { Text, FlexContainer, ConfirmFooterButtons, IconContainer, Icon } from '../../common';

notification.config({
    placement: 'topRight',
    duration: 3
});

const ModalConfirmation = ({ onClose, visible, updateSustitutions, loading }) => {
    return <Modal
        footer={null}
        visible={visible}
        onCancel={() => onClose()}
    >
        <FlexContainer style={{ marginBottom: 70 }} direction='column' align='center'>
            <IconContainer color='#ffffff' size={70}>
                <Icon name='caution' color='#D60000' size={46.8} />
            </IconContainer>
            <Text text={'¿Estás seguro de guardar cambios?'} strong />
            <Text text={'Al aceptar, se modificarán los % de sustitución en las tiendas seleccionadas.'} />
        </FlexContainer>
        <ConfirmFooterButtons
            loading={loading}
            justify='right'
            onCancel={() => onClose()}
            confirmLabel={'btn.action.confirm'}
            onConfirm={updateSustitutions}
            widthButtons={100}
        />
    </Modal>;
};

ModalConfirmation.propTypes = {
    onClose: func,
    visible: bool,
    updateSustitutions: func,
    loading: bool
};

export default ModalConfirmation;
